import * as VARIANTS from './commons/components/variants';
export const RELOADED_VARIANTS = {
    ...VARIANTS,
};
//# sourceMappingURL=variants.js.map